import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { numberInputDriverFactory as publicDriverFactory } from './NumberInput.uni.driver';

export const numberInputDriverFactory = (base: UniDriver, body: UniDriver) => {
  return {
    ...publicDriverFactory(base, body),

    // Add here driver methods that considered "private"
  };
};
